export function segment(v: number, from: number, to: number): number {
  return Math.min(1, Math.max(0, (v - from) / (to - from)));
}

export function partingFor(viewportWidth: number, markWidth: number): number {
  return Math.max(0, Math.min(0.06 * viewportWidth, (viewportWidth - markWidth) / 2 - 6));
}

export function dropFor(stageHeight: number, ringCentreY: number): number {
  return Math.max(0, 0.47 * stageHeight - ringCentreY);
}
